import { useEffect, useState } from "react"
import { downloadExcel } from "react-export-table-to-excel";
import React from 'react'
import './style.scss'


const ExportExcellFile = ({
    columns,
    dataList
}) => {


    const BtnExportExcell = () => {
        handleExportExellFile(columns, dataList)
    }


    return (
        <>
            <button onClick={BtnExportExcell} className="jsTable-btn-excell-export">
                Export CSV
            </button>
        </>

    )

}


const handleExportExellFile = (columns, dataList) => {

    let columnsTitle = []
    columns.forEach((item) => {
        columnsTitle.push(item.title)
    })

    let valueList = []


    dataList.forEach((item) => {
        let tempList = []
        columns.forEach((col) => {
            tempList.push(item[col.property])
        })
        valueList.push(tempList)

    })
    downloadExcel({
        fileName: "TransactonExcell",
        sheet: "TransactonExcell-excel",
        tablePayload: {
            header: columnsTitle,
            body: valueList,
        },
    })
}

export default ExportExcellFile